import { Injectable } from '@angular/core';
import { BaseDAO } from './baseDAO';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { Market } from 'anchor-shared/lib/model/entity/market';

@Injectable()
export class MarketDAO extends BaseDAO<Market> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.MARKET);
  }

  getAllMarkets(): Observable<Market[]> {
    let url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/';
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<Market[]>(url, method, null, null, headers);
  }
}
